import React, { Component } from 'react';
import { Column, Row, Grid, cls, List } from 'packages/components';
import { VCARD_MATCH_RESUME, IN_PROGRESS } from '../utils/constants';
import './_styles.scss';
import getSummary from 'src/mundial/requests/api/getSummary';
import { Match, TeamStatsByMatch } from 'src/mundial/requests/interfaces';
import { KEYS_SUMMARY, ROWS } from '../utils/index';
import {showSoccerWorldCup} from 'src/utils/Utils';
import { getStatusPlay } from '../../../utls/utils';
import Asset from 'src/requests/apa/Asset';

interface IText {
    text: string;
}
interface IRsumeProps {
    team1?: any;
    team2?: any;
    score?: string;
}
export class Resume extends Component<IRsumeProps> {
    rows: IText[];
    state: {
        teamHome: IText[];
        teamAway: IText[];
        score: string[];
        flagHome: string;
        flagAway: string;
        currentPeriod: string;
        interval?: NodeJS.Timeout
    };
    constructor(props: IRsumeProps) {
        super(props);
        this.rows = ROWS;
        this.state = {
            teamHome: [],
            teamAway: [],
            score: ['0', '0'],
            flagHome: '',
            flagAway: '',
            currentPeriod: '1er tiempo',
        };

        this.getSummariesByTeam = this.getSummariesByTeam.bind(this);
        this.requestSummary = this.requestSummary.bind(this);
        this.getInfoMatch = this.getInfoMatch.bind(this);
    }

    getSummariesByTeam = (data: TeamStatsByMatch) => {
        const summary: IText[] = [];
        let goals: string = data.goals;
        KEYS_SUMMARY.forEach((key: string) => {
            const value = key === 'ballPossession' ? `${data[key] || 0}%` : data[key];
            summary.push({ text: value || '0' });
        });
        return { summary, goals };
    };

    getInfoMatch = () => {
        const dataMatch: Match = JSON.parse(localStorage.getItem('match') || '{}');
        const { awayTeam, homeTeam, currentPeriod = '' } = dataMatch;
        const valueCurrentPeriod: string = 
            currentPeriod && (currentPeriod !==  null || currentPeriod !== undefined || currentPeriod !== '')
                    ? getStatusPlay(currentPeriod, null)
                    : '';
        this.setState({
            flagHome: homeTeam.flag ? homeTeam.flag : '',
            flagAway: awayTeam.flag ? awayTeam.flag : '',
            currentPeriod: valueCurrentPeriod,
        });
    };

    requestSummary = async () => {
        const { match: { params } } = this.props;
        const matchId = params[0].split('/')[3];
        const resp = await getSummary(matchId);
        const data = resp || [{}, {}];
        return data;
    };

    async componentDidMount() {
        const updateSecondComents = showSoccerWorldCup();
        const dataMatch: Match = JSON.parse(localStorage.getItem('match') || '{}');
        let interval: any;

        const requestSummary = await this.requestSummary();
        if(dataMatch.status ===  IN_PROGRESS){
            interval = setInterval(async () => {
                const newrequestSummary = await this.requestSummary();
                this.updateDataResume(newrequestSummary);
            }, updateSecondComents.interval_time * 1000)
        }
        this.updateDataResume(requestSummary, interval);
    }

    updateDataResume(requestSummary: any, interval?: any){
        const [dataHome, dataAway] = requestSummary;
        const { summary: teamHome, goals: goalsHome } = this.getSummariesByTeam(dataHome);
        const { summary: teamAway, goals: goalsAway } = this.getSummariesByTeam(dataAway);
        if(interval !== undefined){
            this.setState({ teamHome, teamAway, score: [goalsHome, goalsAway], interval });
        }else {
            this.setState({ teamHome, teamAway, score: [goalsHome, goalsAway] });
        }
        this.getInfoMatch();
    }

    componentWillUnmount() {
        const { interval } = this.state;
        if (interval) {
            clearInterval(interval);
            this.setState({ interval:null });
        }
    }

    render() {
        const { teamHome, teamAway, score, flagHome, flagAway, currentPeriod } = this.state;
        const [scoreHome, scoreAway] = score;
        return (
            <Grid className={`${VCARD_MATCH_RESUME}-resume-container`}>
                <Row>
                    <Column lg={4} />
                    <Column
                        lg={1}
                        className={cls(VCARD_MATCH_RESUME, `${VCARD_MATCH_RESUME}-team1`)}
                    >
                        <img className={`${!flagHome ? 'image-placeholder-left' : ''}`} src={flagHome || Asset.get('vcard_team_placeholder_img')} alt="team1" />
                    </Column>
                    <Column lg={2}>
                        <div className={cls(VCARD_MATCH_RESUME, `${VCARD_MATCH_RESUME}-score`)}>
                            <span>{`${scoreHome || 0} - ${scoreAway || 0}`}</span>
                        </div>
                    </Column>
                    <Column
                        lg={1}
                        className={cls(VCARD_MATCH_RESUME, `${VCARD_MATCH_RESUME}-team2`)}
                    >
                        <img className={`${!flagAway ? 'image-placeholder-right' : ''}`} src={flagAway || Asset.get('vcard_team_placeholder_img')} alt="team2" />
                    </Column>
                    <Column lg={4} />
                </Row>
                <Row>
                    <Column lg={12} className={`${VCARD_MATCH_RESUME}-time-container`}>
                        <span className={`${VCARD_MATCH_RESUME}-time`}>{currentPeriod}</span>
                    </Column>
                </Row>
                <Row>
                    <Column lg={4} />
                    <Column lg={1} className={`${VCARD_MATCH_RESUME}-data-team1`}>
                        <List variant="default" items={teamHome} />
                    </Column>
                    <Column lg={2} className={`${VCARD_MATCH_RESUME}-info`}>
                        <List variant="default" items={this.rows} />
                    </Column>
                    <Column lg={1} className={`${VCARD_MATCH_RESUME}-data-team2`}>
                        <List variant="default" items={teamAway} />
                    </Column>
                    <Column lg={4} />
                </Row>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Resume/index.tsx